export const contractNoteMapper = (resp) => {
    if (resp) {
        return resp.map((val) => {
            return {
                attID: val.attID,
                mailID: val.mailID,
                fileName: val.fileName,
                filePath: val.filePath,
                mk: val.mk,
                fileDate: val.fileDate,
                fileType: val.fileType,
                pdfFileName: val.pdfFileName,
                segment: val.segment,
            };
        });
    }
    return [];
};
